module.exports = {"140107001":"巨轮街道","140107002":"三桥街道","140107003":"鼓楼街道","140107004":"杏花岭街道","140107005":"坝陵桥街道","140107006":"大东关街道","140107007":"职工新街街道","140107008":"敦化坊街道","140107009":"涧河街道","140107010":"杨家峪街道","140107200":"中涧河乡","140107201":"小返乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/140107.json
// module id = 261
// module chunks = 0